import { apiGet } from '../ApiClient';

/**
 * Fetch customers matching a search term.
 * Uses the standard Frappe resource API.
 *
 * @param {string} searchTerm - Partial name / ID to filter by
 * @returns {Promise<Array>} Array of { name, customer_name }
 */
export async function fetchCustomers(searchTerm = '') {
  const filters = searchTerm
    ? JSON.stringify([
        ['customer_name', 'like', `%${searchTerm}%`],
      ])
    : undefined;

  const res = await apiGet('resource/Customer', {
    fields: JSON.stringify(['name', 'customer_name']),
    filters,
    limit_page_length: 20,
    order_by: 'customer_name asc',
  });
  return res?.data || [];
}
